import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

type FeedProps = HTMLAttributes<HTMLDivElement>;

export function Feed({ className, ...props }: FeedProps) {
  return <div className={cn("flex flex-col", className)} {...props} />;
}

type FeedItemProps = {
  icon?: ReactNode;
  title: string;
  meta?: string;
  amount?: ReactNode;
  iconBg?: string;
  className?: string;
};

export function FeedItem({
  icon,
  title,
  meta,
  amount,
  iconBg,
  className,
}: FeedItemProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 py-2.5",
        "border-b border-stroke last:border-0",
        className,
      )}
    >
      {icon && (
        <div
          className={cn(
            "grid h-8 w-8 shrink-0 place-items-center rounded-lg text-xs",
            iconBg ?? "bg-surface-raised",
          )}
        >
          {icon}
        </div>
      )}
      <div className="min-w-0 flex-1">
        <div className="text-[13px] font-medium text-ink leading-[1.35]">{title}</div>
        {meta && (
          <div className="mono mt-0.5 text-[11px] text-ink-dim -tracking-[0.005em]">
            {meta}
          </div>
        )}
      </div>
      {amount !== undefined && (
        <div className="mono text-[13px] font-semibold">{amount}</div>
      )}
    </div>
  );
}
